/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
import * as R from 'ramda';
import ModalImage from "react-modal-image";
/**
 * The internal dependencies.
 */

import FlexRootWrapper from '../../../components/general/flex-root';
import Materials from '../../../components/task/working/materials';
import Child from "../child";


const MyFlexRoot = styled(FlexRootWrapper)``;
const MyFlexRootRow = styled(FlexRootWrapper)`
        flex-direction: row;
        width: 100%;
`;
const MyFlexRootColumn = styled(FlexRootWrapper)`
        flex-direction: column;
        flex: 1;
`;
const MyFlexRootColumnBig = styled(FlexRootWrapper)`
        flex-direction: column;
        flex: 3;
`;
const MainWrapper = styled(FlexRootWrapper)`
	width: 100%;
	flex-direction: row;
	border-right: 1px solid #e2e3e3;
	padding-top: 16px;
	flex: auto;
`;

const AdditionalWrapper = styled(FlexRootWrapper)`
	flex-direction: row;
    padding-top: 16px;
    margin-left: 20px;
    flex: auto;
`;

const ImageWrapper = styled.div`
	width: 60%;
	min-width: 290px;
	margin-right: 20px;
`;


const DescriptionWrapper = styled.div`
	padding-right: 10px;
`;

const DescriptionText = styled.p`
	padding-bottom: ${({padding}) => padding}px;
	margin-top: ${({margin}) => margin}px;
	${({big}) => big ? 'font-size: 20px;' : ''}
`;

const ChildrenContainer = styled.div`

`

const Content = ({
                     image,
                     stepNumber,
                     step,
                     materials,
                     children,
                     instructions,
                     description,
                 }) => (
    <MyFlexRoot>
        <MyFlexRootRow>
            <MyFlexRootColumnBig>
                <MainWrapper>

                    <ImageWrapper>
                        {instructions && instructions.length > 0 && instructions.map((instruction, index) =>
                            <ModalImage
                                small={instruction._links.resourcesEntity.href}
                                large={instruction._links.resourcesEntity.href}
                                alt=""
                                key={'content-modal-' + index}
                            />
                        )}

                    </ImageWrapper>



                    <DescriptionWrapper>
                        <DescriptionText big padding={3}>Arbeitsschritt {stepNumber}: {step} </DescriptionText>

                        {description && <DescriptionText margin={10} padding={27}>Beschreibung: {description}</DescriptionText>}

                        {R.length(instructions) > 0 && instructions[0].content && (
                            <Materials materials={instructions[0].content}/>
                        )}

                    </DescriptionWrapper>
                </MainWrapper>
            </MyFlexRootColumnBig>
            <MyFlexRootColumn>
                    {children && <Child children={children}/>}
            </MyFlexRootColumn>
        </MyFlexRootRow>
    </MyFlexRoot>
);

export default Content;



// WEBPACK FOOTER //
// ./src/components/task/working/content.js